// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2SfnM","top":"styles_top__2-1Lt","left":"styles_left__-5bey","description":"styles_description__OOF8H"};